/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthImpersonate,
  DashboardImpersonateResult,
  DashboardImpersonationAllowedApps,
  DashboardImpersonationControllerAllowedApps400,
  DashboardImpersonationControllerAllowedApps401,
  DashboardImpersonationControllerAllowedApps403,
  DashboardImpersonationControllerAllowedApps404,
  DashboardImpersonationControllerAllowedApps429,
  DashboardImpersonationControllerImpersonate400,
  DashboardImpersonationControllerImpersonate401,
  DashboardImpersonationControllerImpersonate403,
  DashboardImpersonationControllerImpersonate404,
  DashboardImpersonationControllerImpersonate429,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns RBAC-native app choices for an impersonation modal after enforcing the caller’s USER:IMPERSONATE capability against the target. Dashboard requires at least one readable platform, federation, or league; manager requires at least one readable tournament; client is always returned. The token-mint endpoint repeats the suitability check.
 * @summary List eligible impersonation apps for a user
 */
export const dashboardImpersonationControllerAllowedApps = (
  targetUserPublicId: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardImpersonationAllowedApps>(
    {
      url: `/api/dashboard/v1/impersonation/users/${targetUserPublicId}/allowed-apps`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getDashboardImpersonationControllerAllowedAppsQueryKey = (
  targetUserPublicId: string
) => {
  return [`/api/dashboard/v1/impersonation/users/${targetUserPublicId}/allowed-apps`] as const;
};

export const getDashboardImpersonationControllerAllowedAppsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
  TError = ErrorType<
    | DashboardImpersonationControllerAllowedApps400
    | DashboardImpersonationControllerAllowedApps401
    | DashboardImpersonationControllerAllowedApps403
    | DashboardImpersonationControllerAllowedApps404
    | DashboardImpersonationControllerAllowedApps429
  >,
>(
  targetUserPublicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDashboardImpersonationControllerAllowedAppsQueryKey(targetUserPublicId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>
  > = ({ signal }) =>
    dashboardImpersonationControllerAllowedApps(targetUserPublicId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!targetUserPublicId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardImpersonationControllerAllowedAppsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>
>;
export type DashboardImpersonationControllerAllowedAppsQueryError = ErrorType<
  | DashboardImpersonationControllerAllowedApps400
  | DashboardImpersonationControllerAllowedApps401
  | DashboardImpersonationControllerAllowedApps403
  | DashboardImpersonationControllerAllowedApps404
  | DashboardImpersonationControllerAllowedApps429
>;

export function useDashboardImpersonationControllerAllowedApps<
  TData = Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
  TError = ErrorType<
    | DashboardImpersonationControllerAllowedApps400
    | DashboardImpersonationControllerAllowedApps401
    | DashboardImpersonationControllerAllowedApps403
    | DashboardImpersonationControllerAllowedApps404
    | DashboardImpersonationControllerAllowedApps429
  >,
>(
  targetUserPublicId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardImpersonationControllerAllowedApps<
  TData = Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
  TError = ErrorType<
    | DashboardImpersonationControllerAllowedApps400
    | DashboardImpersonationControllerAllowedApps401
    | DashboardImpersonationControllerAllowedApps403
    | DashboardImpersonationControllerAllowedApps404
    | DashboardImpersonationControllerAllowedApps429
  >,
>(
  targetUserPublicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardImpersonationControllerAllowedApps<
  TData = Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
  TError = ErrorType<
    | DashboardImpersonationControllerAllowedApps400
    | DashboardImpersonationControllerAllowedApps401
    | DashboardImpersonationControllerAllowedApps403
    | DashboardImpersonationControllerAllowedApps404
    | DashboardImpersonationControllerAllowedApps429
  >,
>(
  targetUserPublicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List eligible impersonation apps for a user
 */

export function useDashboardImpersonationControllerAllowedApps<
  TData = Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
  TError = ErrorType<
    | DashboardImpersonationControllerAllowedApps400
    | DashboardImpersonationControllerAllowedApps401
    | DashboardImpersonationControllerAllowedApps403
    | DashboardImpersonationControllerAllowedApps404
    | DashboardImpersonationControllerAllowedApps429
  >,
>(
  targetUserPublicId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardImpersonationControllerAllowedApps>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardImpersonationControllerAllowedAppsQueryOptions(
    targetUserPublicId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Mint a short-lived JWT for a target user. The caller must hold USER:IMPERSONATE on one of the target’s platforms; self-impersonation and impersonating a superAdmin are rejected. Dashboard suitability requires a readable platform, federation, or league; manager suitability requires a readable tournament; client has no suitability check. Defaults to dashboard.
 * @summary Impersonate a user (dashboard)
 */
export const dashboardImpersonationControllerImpersonate = (
  authImpersonate: BodyType<AuthImpersonate>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardImpersonateResult>(
    {
      url: `/api/dashboard/v1/impersonate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authImpersonate,
      signal,
    },
    options
  );
};

export const getDashboardImpersonationControllerImpersonateMutationOptions = <
  TError = ErrorType<
    | DashboardImpersonationControllerImpersonate400
    | DashboardImpersonationControllerImpersonate401
    | DashboardImpersonationControllerImpersonate403
    | DashboardImpersonationControllerImpersonate404
    | DashboardImpersonationControllerImpersonate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardImpersonationControllerImpersonate>>,
    TError,
    { data: BodyType<AuthImpersonate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardImpersonationControllerImpersonate>>,
  TError,
  { data: BodyType<AuthImpersonate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardImpersonationControllerImpersonate>>,
    { data: BodyType<AuthImpersonate> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardImpersonationControllerImpersonate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardImpersonationControllerImpersonateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardImpersonationControllerImpersonate>>
>;
export type DashboardImpersonationControllerImpersonateMutationBody = BodyType<AuthImpersonate>;
export type DashboardImpersonationControllerImpersonateMutationError = ErrorType<
  | DashboardImpersonationControllerImpersonate400
  | DashboardImpersonationControllerImpersonate401
  | DashboardImpersonationControllerImpersonate403
  | DashboardImpersonationControllerImpersonate404
  | DashboardImpersonationControllerImpersonate429
>;

/**
 * @summary Impersonate a user (dashboard)
 */
export const useDashboardImpersonationControllerImpersonate = <
  TError = ErrorType<
    | DashboardImpersonationControllerImpersonate400
    | DashboardImpersonationControllerImpersonate401
    | DashboardImpersonationControllerImpersonate403
    | DashboardImpersonationControllerImpersonate404
    | DashboardImpersonationControllerImpersonate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardImpersonationControllerImpersonate>>,
    TError,
    { data: BodyType<AuthImpersonate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardImpersonationControllerImpersonate>>,
  TError,
  { data: BodyType<AuthImpersonate> },
  TContext
> => {
  const mutationOptions = getDashboardImpersonationControllerImpersonateMutationOptions(options);

  return useMutation(mutationOptions);
};
